module.exports = __webpack_public_path__ + "static/media/new-library-transforming-nuneaton.9b1439c3.png";